import {AxiosError} from 'axios';
import {POST_ACCESS_CONFIG_URL} from 'web-library/constants/apiUrls';
import {
  CreateAccessConfigRequestBody
} from 'web-library/models/UserGroupAccessConfiguration/UserGroupAccessConfiguration';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

interface Input {
  onSuccess?: (res: CreateAccessConfigRequestBody) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostAccessConfig = ({onError, onSuccess}: Input = {}) => {
  const postAccessConfig = async (reqBody: any) => {
    const res = await axiosClient.post<CreateAccessConfigRequestBody>(
        POST_ACCESS_CONFIG_URL,
        reqBody
    );

    return res.data;
  };

  return useCustomMutation(postAccessConfig, {
    onSuccess,
    onError,
  });
};
